<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="front01"><a id="page_i">Praise for <em>Catching the Catfishers</em></a></p><a id="page_i">
<p class="indentb">“If you have ever simply gone online, perhaps used social media or even just taken a picture with your smart phone, you likely have no idea about the obvious digital trail you have willingly left behind that others can follow to potentially use against you. Many different industries, from insurance and credit card companies, to employers, schools, and law enforcement already use this data to your disadvantage. And then there are the online bullies and predators preying on your kids. This is a truly remarkable must-read book. Finally, we have a clear and honest, behind-the-scenes guide for anyone who cares to protect the online personal and professional reputations of themselves and their children. The information in <em>Catching the Catfishers</em> is nothing short of astounding. Tyler Cohen Wood is a cyber security expert with Department of Defense credentials and is willing to share what she has learned. Thankfully her style is direct, understandable, and down-to-earth. One warning: At first you may be a little shocked or frightened as you read this book (frankly, you should be), but Ms. Wood offers many sound and practical steps you can take to protect yourself and your family. This book covers it all. We are even told how experts can tell when someone we are communicating with online is trying to lie and deceive us. It’s a new world, and this manual should be in every home.”</p>
<p class="noindent">—Dr. Dean Edell, host, <em>Dr. Dean Edell Show</em>, author of <em>Life, Liberty, and the Pursuit of Healthiness</em>, and winner of many awards such as a national Emmy</p>
</a><p class="noindent"><a id="page_i"></a><a id="page_ii"></a></p><a id="page_ii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?7948717e